// extracted by mini-css-extract-plugin
var _1 = "ListingProfileApplicantsMatchRulesModal-modulebox__ZkNI8 Box-modulebox__T8Mz4";
export { _1 as "box" }
